import { render, staticRenderFns } from "./InternalInvoices.vue?vue&type=template&id=3ddaa12b"
import script from "./InternalInvoices.vue?vue&type=script&lang=js"
export * from "./InternalInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports